import { useState, useEffect } from "react";
import { PrivacyPolicyContext } from 'volto-fzj-internet/components/manage/PrivacyPolicy/PrivacyPolicyContext';
import { useCookies } from 'react-cookie';

export default function PrivacyPolicyProvider({ children }) {
  const [cookies, setCookies] = useCookies(["youtube", "vimeo", "google"]);
  useEffect(() => {
    if (!cookies.youtube) setCookies("youtube", false, { path: "/" });
    if (!cookies.vimeo) setCookies("vimeo", false, { path: "/" });
    if (!cookies.google) setCookies("google", false, { path: "/" });
  }, []);
  return (
    <PrivacyPolicyContext.Provider value={{ cookies, setCookies }}>
      {children}
    </PrivacyPolicyContext.Provider>
  );
}
